import { Input as AntInput } from 'antd'
import type { ComponentProps } from 'react'
import { SIZE_MAP } from '../types'
import type { Size } from '../types'

type AntTextAreaProps = ComponentProps<typeof AntInput.TextArea>

export interface AppTextAreaProps extends Omit<AntTextAreaProps, 'size'> {
  size?: Size
}

export const AppTextArea = ({ size = 'md', ...rest }: AppTextAreaProps) => (
  <AntInput.TextArea size={SIZE_MAP[size]} {...rest} />
)
